<template>
  <div>
    <v-layout v-if="fieldPath[0]!=='selectEntireListOfEducationsAndCertifications'" wrap style="position: fixed; top: 85px; background:white; z-index:2; width: 50%">
      <v-flex xs12 pt-4 pb-8>
        <v-divider />
      </v-flex>
      <v-flex xs3 pl-4 style="margin-bottom: 15px">
        <v-btn v-if="!isUsingSelectEntireExperience && !isUsingSelectEntireEducationOrCertification" small class="primary" @click="goBackToMainForm" ref="backButton">
          <v-icon small class="mr-2">mdi-arrow-left</v-icon>
          {{ $t('a') }}
        </v-btn>
      </v-flex>
      <v-flex xs9 class="text-left">
        <v-layout wrap>
          <v-flex>
            <h2>{{ fieldTitle }}</h2>
          </v-flex>
          <v-spacer/>
          <v-flex xs2 text-end pr-1>
            <v-tooltip bottom v-if="isShowingGoToEditPreviousItemButton">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab @click="goToEditPreviousItem" x-small elevation="0" v-bind="attrs" v-on="on">
                  <v-icon small>mdi-arrow-left</v-icon>
                </v-btn>
              </template>
              <small>
                <div v-html="goToEditPreviousItemButtonText"/>
              </small>
            </v-tooltip>
          </v-flex>
          <v-flex xs2 text-left pl-1>
            <v-tooltip bottom v-if="isShowingGoToEditNextItemButton">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab @click="goToEditNextItem" x-small elevation="0" v-bind="attrs" v-on="on">
                  <v-icon small>mdi-arrow-right</v-icon>
                </v-btn>
              </template>
              <small>
                <div v-html="goToEditNextItemButtonText"/>
              </small>
            </v-tooltip>
          </v-flex>
          <v-flex xs2 text-end pr-4>
             <v-tooltip top v-if="isShowingAddAnItemButton">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab @click="addAnItem" x-small elevation="0" v-bind="attrs" v-on="on">
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </template>
              <small>{{ addAnItemButtonText }}</small>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap :style="fieldPath[0]==='selectEntireListOfEducationsAndCertifications' ? 'margin-top: 15px' : 'margin-top: 85px'">
      <v-flex xs12>
        <edit-basics v-if="fieldPath[0]==='basics'" class="mt-6" :dossier="dossier" :isOcrResultsLoaded="isOcrResultsLoaded" :isConsultant="isConsultant" :isFromToken="isFromToken"  @setFieldPath="setFieldPath" @goBackToMainForm="goBackToMainForm"/>
        <edit-technical-skills v-if="fieldPath[0]==='technicalSkills'" class="mt-6" :profile="dossier.profile" :dossier="dossier" :isOcrResultsLoaded="isOcrResultsLoaded" @setFieldPath="setFieldPath" @goBackToMainForm="goBackToMainForm" />
        <edit-functional-skills v-if="fieldPath[0]==='functionalSkills'"  class="mt-6" :profile="dossier.profile" :isOcrResultsLoaded="isOcrResultsLoaded" @setFieldPath="setFieldPath" @goBackToMainForm="goBackToMainForm" />
        <edit-languages v-if="fieldPath[0]==='languages'" class="mt-10" :profile="dossier.profile"/>
        <edit-education v-if="fieldPath[0]==='educations'" :index="this.fieldPath[1]" :profile="dossier.profile" :isOcrResultsLoaded="isOcrResultsLoaded" :isFromToken="isFromToken" @passIsUsingSelectEntireEducationOrCertification="passIsUsingSelectEntireEducationOrCertification" @setFieldPath="setFieldPath" @goBackToMainForm="goBackToMainForm" @updateProfileAndCreateDossier="updateProfileAndCreateDossier" @showIsSavingIconAFewSeconds="showIsSavingIconAFewSeconds" @goToEditPreviousItem="goToEditPreviousItem" @goToEditNextItem="goToEditNextItem"/>
        <edit-certification v-if="fieldPath[0]==='certifications'" :index="this.fieldPath[1]" :profile="dossier.profile" :isOcrResultsLoaded="isOcrResultsLoaded" :isFromToken="isFromToken" @passIsUsingSelectEntireEducationOrCertification="passIsUsingSelectEntireEducationOrCertification" @setFieldPath="setFieldPath" @goBackToMainForm="goBackToMainForm" @updateProfileAndCreateDossier="updateProfileAndCreateDossier" @showIsSavingIconAFewSeconds="showIsSavingIconAFewSeconds" @goToEditPreviousItem="goToEditPreviousItem" @goToEditNextItem="goToEditNextItem"/>
        <edit-experience v-if="fieldPath[0]==='experiences'" :index="this.fieldPath[1]" :profile="dossier.profile" :isOcrResultsLoaded="isOcrResultsLoaded" :isFromToken="isFromToken" @passIsUsingSelectEntireExperience="passIsUsingSelectEntireExperience" @setFieldPath="setFieldPath" @goBackToMainForm="goBackToMainForm" @goToEditPreviousItem="goToEditPreviousItem" @goToEditNextItem="goToEditNextItem"/>
        <select-entire-list-of-educations-and-certifications v-if="fieldPath[0]==='selectEntireListOfEducationsAndCertifications'" :profile="dossier.profile" :isOcrResultsLoaded="isOcrResultsLoaded" :isFromToken="isFromToken" @goBackToMainForm="goBackToMainForm"/>
      </v-flex>
    </v-layout>
    
  </div>
</template>



<script>
import lodash from 'lodash';

import EditBasics from '@/components/profile/EditBasics.vue';
import EditTechnicalSkills from '@/components/profile/EditTechnicalSkills.vue';
import EditFunctionalSkills from '@/components/profile/EditFunctionalSkills.vue';
import EditLanguages from '@/components/profile/EditLanguages.vue';
import EditEducation from '@/components/profile/EditEducation.vue'
import EditCertification from '@/components/profile/EditCertification.vue'
import EditExperience from '@/components/profile/EditExperience.vue'
import SelectEntireListOfEducationsAndCertifications from './SelectEntireListOfEducationsAndCertifications.vue';

export default {
  components: {
    EditBasics,
    EditTechnicalSkills,
    EditFunctionalSkills,
    EditLanguages,
    EditEducation,
    EditCertification,
    EditExperience,
    SelectEntireListOfEducationsAndCertifications
  },
  props: {
    dossier: Object,
    fieldPath: Array,
    isOcrResultsLoaded: Boolean,
    isConsultant: Boolean,
    isFromToken: Boolean,
    isUsingSelectEntireExperience: Boolean,
    isUsingSelectEntireEducationOrCertification: Boolean
  },
  computed: {
    fieldTitle() {
      let str = {
        'basics': this.$t('fieldTitle0'),
        'technicalSkills': this.$t('fieldTitle1'),
        'functionalSkills': this.$t('fieldTitle2'),
        'languages': this.$t('fieldTitle3'),
        'educations': this.$t('fieldTitle4'),
        'certifications': this.$t('fieldTitle5'),
        'experiences': this.$t('fieldTitle6'),
        'selectEntireListOfEducationsAndCertifications': this.$t('fieldTitle7')
      }[this.fieldPath[0]]
      if (this.fieldPath.length >= 2) str += ` ${this.fieldPath[1] + 1}`
      return str
    },
    goToEditPreviousItemButtonText() {
      const fieldPath = JSON.parse(JSON.stringify(this.fieldPath))
      fieldPath[1] -= 1
      const previousItem = lodash.get(this.dossier.profile, fieldPath)

      if (fieldPath[0] === 'educations') {
        const part1 = `<div class="text-center"><b>${this.$t('goToEditPreviousItem1')}</b></div>`
        const part2 = `<div>${[
          [previousItem.startYear, previousItem.endYear].filter(Boolean).join(' - '),
          previousItem.institute,
          previousItem.description
        ].filter(Boolean).join(' - ')}</div>`
        return `${part1}${part2}`
      }
      if (fieldPath[0] === 'certifications' ) {
        const part1 = `<div class="text-center"><b>${this.$t('goToEditPreviousItem2')}</b></div>`
        const part2 = `<div>${[
          [previousItem.startYear, previousItem.endYear].filter(Boolean).join(' - '),
          previousItem.institute,
          previousItem.description
        ].filter(Boolean).join(' - ')}</div>`
        return `${part1}${part2}`
      }
      if (fieldPath[0] === 'experiences' ) {
        const part1 = `<div class="text-center"><b>${this.$t('goToEditPreviousItem3')}</b></div>`
        const part2 = `<div>${[
          [previousItem.startDate, previousItem.endDate].filter(Boolean).join(' - '),
          previousItem.company,
          previousItem.title
        ].filter(Boolean).join(' - ')}</div>`
        return `${part1}${part2}`
      }
      return ''
    },
    goToEditNextItemButtonText() {
      const fieldPath = JSON.parse(JSON.stringify(this.fieldPath))
      fieldPath[1] += 1
      const nextItem = lodash.get(this.dossier.profile, fieldPath)

      if (fieldPath[0] === 'educations') {
        const part1 = `<div class="text-center"><b>${this.$t('goToEditNextItem1')}</b></div>`
        const part2 = `<div>${[
          [nextItem.startYear, nextItem.endYear].filter(Boolean).join(' - '),
          nextItem.institute,
          nextItem.description
        ].filter(Boolean).join(' - ')}</div>`
        return `${part1}${part2}`
      }
      if (fieldPath[0] === 'certifications' ) {
        const part1 = `<div class="text-center"><b>${this.$t('goToEditNextItem2')}</b></div>`
        const part2 = `<div>${[
          [nextItem.startYear, nextItem.endYear].filter(Boolean).join(' - '),
          nextItem.institute,
          nextItem.description
        ].filter(Boolean).join(' - ')}</div>`
        return `${part1}${part2}`
      }
      if (fieldPath[0] === 'experiences' ) {
        const part1 = `<div class="text-center"><b>${this.$t('goToEditNextItem3')}</b></div>`
        const part2 = `<div>${[
          [nextItem.startDate, nextItem.endDate].filter(Boolean).join(' - '),
          nextItem.company,
          nextItem.title
        ].filter(Boolean).join(' - ')}</div>`
        return `${part1}${part2}`
      }
      return ''
    },
    addAnItemButtonText() {
      return {
        'educations': this.$t('addAnItem1'),
        'certifications': this.$t('addAnItem2'),
        'experiences': this.$t('addAnItem3'),
      }[this.fieldPath[0]] || ''
    },
    isShowingGoToEditPreviousItemButton() {
      if (this.fieldPath[0] === 'educations') {
        if (this.isUsingSelectEntireEducationOrCertification) return false
        return this.fieldPath[1] > 0
      } else if (this.fieldPath[0] === 'certifications') {
        if (this.isUsingSelectEntireEducationOrCertification) return false
        return this.fieldPath[1] > 0
      } else if (this.fieldPath[0] === 'experiences') {
        if (this.isUsingSelectEntireExperience) return false
        return this.fieldPath[1] > 0
      } else {
        return false
      }
    },
    isShowingGoToEditNextItemButton() {
      if (this.fieldPath[0] === 'educations') {
        if (this.isUsingSelectEntireEducationOrCertification) return false
        return this.fieldPath[1] < this.dossier.profile.educations.length - 1
      } else if (this.fieldPath[0] === 'certifications') {
        if (this.isUsingSelectEntireEducationOrCertification) return false
        return this.fieldPath[1] < this.dossier.profile.certifications.length - 1
      } else if (this.fieldPath[0] === 'experiences') {
        if (this.isUsingSelectEntireExperience) return false
        return this.fieldPath[1] < this.dossier.profile.experiences.length - 1
      } else {
        return false
      }
    },
    isShowingAddAnItemButton() {
      if (this.isUsingSelectEntireEducationOrCertification) return false
      if (this.isUsingSelectEntireExperience) return false
      return ['educations', 'certifications', 'experiences'].includes(this.fieldPath[0]) 
    },
  },
  methods: {
    setFieldPath(data) {
      this.$emit('setFieldPath', data)
    },
    goToEditPreviousItem() {
      const fieldPath = JSON.parse(JSON.stringify(this.fieldPath))
      fieldPath[1] -= 1
      this.$emit('setFieldPath', { fieldPath, savedScrollEltId: `view-${fieldPath[0]}-${fieldPath[1]}` })
      this.$emit('updateProfileAndCreateDossier', { isOnlyToUpdateProfile: true })
      this.$emit('showIsSavingIconAFewSeconds')
    },
    goToEditNextItem() {
      const fieldPath = JSON.parse(JSON.stringify(this.fieldPath))
      fieldPath[1] += 1
      this.$emit('setFieldPath', { fieldPath, savedScrollEltId: `view-${fieldPath[0]}-${fieldPath[1]}` })
      this.$emit('updateProfileAndCreateDossier', { isOnlyToUpdateProfile: true })
      this.$emit('showIsSavingIconAFewSeconds')
    },
    addAnItem() {
      if (this.fieldPath[0] === 'educations') {
        this.dossier.profile.educations.splice(this.fieldPath[1] + 1, 0, {
          startYear: "",
          endYear: "",
          institute: "",
          description: "",
          location: ""
        })
        setTimeout(() => {
          this.goToEditNextItem()
        }, 1)
      } else if (this.fieldPath[0] === 'certifications') {
        this.dossier.profile.certifications.splice(this.fieldPath[1] + 1, 0, {
          startYear: "",
          endYear: "",
          institute: "",
          description: "",
          location: ""
        })
        setTimeout(() => {
          this.goToEditNextItem()
        }, 1)
      } else if (this.fieldPath[0] === 'experiences') {
        this.dossier.profile.experiences.splice(this.fieldPath[1] + 1, 0, {
          startDate: "",
          endDate: "",
          company: "",
          title: "",
          location: "",
          description: "",
          technicalEnv: ""
        })
        setTimeout(() => {
          this.goToEditNextItem()
        }, 1)
      }
    },
    goBackToMainForm(data) {
      // Re-order languages after leaving
      this.dossier.profile.languages = this.dossier.profile.languages.sort((a, b) => {
        if (a.levelNb === null) return 1
        if (b.levelNb === null) return -1
        return b.levelNb - a.levelNb
      })

      // Remove last empty line of experiences description after leaving
      this.dossier.profile.experiences = this.dossier.profile.experiences.map(xp => {
        xp.description = this.removeEmptyLinesAtTheEnd(xp.description)
        return xp
      })

      // Make sure to scroll to the position of the last item edited
      if (this.$refs['backButton']) data.mousePositionFromTop = this.$refs['backButton'].$el.offsetTop
      this.$emit('goBackToMainForm', data)
    },
    removeEmptyLinesAtTheEnd(quillStr) {
      let newQuillStr = quillStr
      if (newQuillStr.endsWith('<p><br></p>')) {
        newQuillStr = newQuillStr.slice(0, -1 * '<p><br></p>'.length)
      }
      if (newQuillStr.endsWith('<ul><li class="ql-indent-0"><br></li></ul>')) {
        newQuillStr = newQuillStr.slice(0, -1 * '<ul><li class="ql-indent-0"><br></li></ul>'.length)
      }
      if (newQuillStr.endsWith('<li class="ql-indent-0"><br></li></ul>')) {
        newQuillStr = newQuillStr.slice(0, -1 * '<li class="ql-indent-0"><br></li></ul>'.length) + '</ul>'
      }
      if (newQuillStr === quillStr) return quillStr
      else return this.removeEmptyLinesAtTheEnd(newQuillStr)
    },
    passIsUsingSelectEntireExperience(data) {
      this.$emit('passIsUsingSelectEntireExperience', data)
    },
    passIsUsingSelectEntireEducationOrCertification(data) {
      this.$emit('passIsUsingSelectEntireEducationOrCertification', data)
    },
    updateProfileAndCreateDossier(data) {
      this.$emit('updateProfileAndCreateDossier', data)
    },
    showIsSavingIconAFewSeconds() {
      this.$emit('showIsSavingIconAFewSeconds')
    },
  }

}
</script>


<i18n>
{
  "fr": {
    "a": "Retour",
    "fieldTitle0": "Présentation",
    "fieldTitle1": "Compétences techniques",
    "fieldTitle2": "Compétences fonctionnelles",
    "fieldTitle3": "Langues",
    "fieldTitle4": "Diplôme",
    "fieldTitle5": "Certification",
    "fieldTitle6": "Expérience",
    "fieldTitle7": "Sélectionner plusieurs diplômes et certifications d'un seul coup",

    "goToEditPreviousItem1": "Diplôme précédent",
    "goToEditPreviousItem2": "Certification précédente",
    "goToEditPreviousItem3": "Expérience précédente",
    "goToEditNextItem1": "Diplôme suivant",
    "goToEditNextItem2": "Certification suivante",
    "goToEditNextItem3": "Expérience suivante",

    "addAnItem1": "Ajouter un diplôme",
    "addAnItem2": "Ajouter une certification",
    "addAnItem3": "Ajouter une expérience"
  },
  "en": {
    "a": "Back",
    "fieldTitle0": "Presentation",
    "fieldTitle1": "Technical skills",
    "fieldTitle2": "Functional skills",
    "fieldTitle3": "Languages",
    "fieldTitle4": "Diploma",
    "fieldTitle5": "Certification",
    "fieldTitle6": "Experience",
    "fieldTitle7": "Select multiple diplomas and certifications at once",
    
    "goToEditPreviousItem1": "Previous diploma",
    "goToEditPreviousItem2": "Previous certification",
    "goToEditPreviousItem3": "Previous experience",
    "goToEditNextItem1": "Next diploma",
    "goToEditNextItem2": "Next certification",
    "goToEditNextItem3": "Next experience",


    "addAnItem1": "Add a diploma",
    "addAnItem2": "Add a certification",
    "addAnItem3": "Add an experience"
  }
}
</i18n>